<div class="conversation-chips" *ngIf="hasPrompts" [attr.aria-label]="label" role="group">
  <button type="button" class="conversation-chips__chip" *ngFor="let prompt of prompts; trackBy: trackByPrompt" [disabled]="disabled" (click)="choose(prompt)">
    {{ prompt }}
  </button>
</div>
